import { render } from "./DetailAttributionPage.vue?vue&type=template&id=863a5398&ts=true"
import script from "./DetailAttributionPage.vue?vue&type=script&lang=ts"
export * from "./DetailAttributionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__